module.exports = __webpack_public_path__ + "img/CZE.0cdacbf3.svg";